const mutations = {
  setUserInstance(state, input) {
    state.userInstance = input;
  },
  setCartInstance(state, input) {
    state.cartInstance = input;
  }
};

export default mutations;
